import { Environment } from '../../config/environment';
import * as config from '../../config/config.json';
import { Backend } from '../Backend';
import {
  IBootstrapConfig,
  IBootstrapDiscover,
  IDeviceProfileElementV1,
  ILoginSessionV3,
  ITimeResponse,
} from '../models/AndromeTV.types';
import * as applicationInfo from '../../config/application-info.json';
import { SysCalls } from '../../syscalls/Syscalls';

export class BootstrapApi {
  static discover(backend: Backend): Promise<IBootstrapDiscover> {
    let osVersion: string | undefined = undefined;
    const platformVersion = SysCalls.platformVersion();
    if (platformVersion.length != 0 && platformVersion != 'unknown') osVersion = platformVersion;
    if (osVersion) {
      return backend.getJson(
        `${Environment.discovery}?platform=${Environment.system}&appVersion=${applicationInfo.version}&osVersion=${osVersion}`
      ) as Promise<IBootstrapDiscover>;
    } else {
      return backend.getJson(
        `${Environment.discovery}?platform=${Environment.system}&appVersion=${applicationInfo.version}`
      ) as Promise<IBootstrapDiscover>;
    }
  }

  /**
   * Retrieves the default config file of the application
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static defaultConfig(backend: Backend): IBootstrapConfig {
    return config;
  }

  /**
   * Retrieve the system specific config file from the backend
   */
  static config(backend: Backend): Promise<IBootstrapConfig> {
    const url = backend.makeUrl(`v2/bootstrap/config/${Environment.system}`);
    return backend.getJson(url) as Promise<IBootstrapConfig>;
  }

  /**
   * Perform the time request
   */
  static timeRequest(backend: Backend): Promise<ITimeResponse> {
    const url = backend.makeUrl('v1/time');
    return backend.getJson(url) as Promise<ITimeResponse>;
  }

  /**
   * Get the current session information
   */
  static sessionInfo(backend: Backend): Promise<ILoginSessionV3> {
    const url = backend.makeUrl('api/v3/session', { appVersion: applicationInfo.version });
    return backend.getJson(url, backend.bearer) as Promise<ILoginSessionV3>;
  }

  /**
   * Delete the current session on the backend (delete access and refresh token)
   */
  static sessionLogout(backend: Backend): Promise<Response> {
    const url = backend.makeUrl('api/v3/session');
    return backend.delete(url, backend.bearer) as Promise<Response>;
  }

  /**
   * Get the device profile for the current deviceId
   */
  static deviceProfile(backend: Backend, deviceId: string): Promise<IDeviceProfileElementV1> {
    const url = backend.makeUrl(`aa/v1/device/${encodeURIComponent(deviceId)}/profile`);
    return backend.getJson(url, backend.bearer) as Promise<IDeviceProfileElementV1>;
  }
}
